import React, {FC, forwardRef, ReactElement} from 'react';

import Dialog from '@mui/material/Dialog';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import Fade from '@mui/material/Fade';
import Chip from '@mui/material/Chip';
import Divider from '@mui/material/Divider';

import {TransitionProps} from '@mui/material/transitions';

import {useTranslation} from 'react-i18next';
import i18n from 'i18next';

import GeomaticoLink from './GeomaticoLink';
import {PANEL_WIDTH} from '@/config';

type AboutPanelProps = {
  isOpen: boolean,
  onClose: () => void
}

const Transition = forwardRef<unknown, TransitionProps & { children: ReactElement }>(
  (props, ref) => <Fade ref={ref} {...props}/>
);

Transition.displayName = 'Transition';


const AboutModal: FC<AboutPanelProps> = ({isOpen, onClose}) => {

  // @ts-expect-error build injected var
  const [version, hash, timestamp] = [VERSION, HASH, DATE];

  const date = new Date(timestamp);

  const formattedDate = new Intl.DateTimeFormat(i18n.language, {
    year: 'numeric',
    month: 'long',
    day: 'numeric',
  }).format(date);

  const {t} = useTranslation();

  return <Dialog
    open={isOpen}
    slots={{transition: Transition}}
    keepMounted
    maxWidth={false}
    fullWidth={false}
    onClose={onClose}
    slotProps={{
      paper: {
        sx: {
          width: PANEL_WIDTH.about
        },
      },
    }}
  >
    <DialogContent>
      <DialogContentText component="div">
        <Stack direction="column" sx={{gap: 1, alignItems: 'center'}}>
          <GeomaticoLink/>
          <Typography sx={{mb: 2, fontStyle: 'italic'}}>
            {t('aboutPanel.openSourceCooperative')}
          </Typography>
        </Stack>
        <Divider sx={{my: 2}}/>
        <Stack direction="row" sx={{gap: 2}}>
          <Stack direction="row" sx={{alignItems: 'center', justifyContent: 'flex-start', gap: 1}}>
            <Typography variant="caption">{t('aboutPanel.version')}</Typography>
            <Chip label={version} size="small" sx={{minWidth: '80px', letterSpacing: 1}}/>
          </Stack>
          <Stack direction="row" sx={{alignItems: 'center', justifyContent: 'flex-start', gap: 1}}>
            <Typography variant="caption">{t('aboutPanel.hash')}</Typography>
            <Chip label={hash} size="small" sx={{minWidth: '80px', letterSpacing: 1}}/>
          </Stack>
        </Stack>

        <Typography variant="caption">{t('aboutPanel.versionUpdatedOn')} {formattedDate}</Typography>
      </DialogContentText>
    </DialogContent>
  </Dialog>;
};
export default AboutModal;